export default __webpack_public_path__ + "681d736a50fbf0b25048edf215bfebe2.js";